import React from "react";
import "./Banner.scss";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../shared/Breadcrumb/Breadcrumbs";
export default function Banner(props) {
  return (
    <div
      style={{ backgroundImage: `url(${props.img})` }}
      className={`banner ${props.styles}`}
    >
      <div
        className="shade"
        style={{ background: `${props.bgcolor}`, opacity: `${props.opacity}` }}
      ></div>
      <div className={`left-right ${props.styles ? props.styles : ""}`}>
        <div
          className="left"
          style={{
            backgroundImage: `url(${props.img})`,
          }}
          data-aos="fade-down"
          data-aos-duration="800"
          data-aos-easing="ease-out-cubic"
        ></div>
        <div
          className="right"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-easing="ease-out-cubic"
        >
          <h3 className="subtitle">{props.subtitle}</h3>
          <h2 className="title">{props.title}</h2>
          <p className="description">{props.description}</p>
          {props.link ? (
            <Link id="main" to={props.to}>
              {props.link}
            </Link>
          ) : null}
        </div>
      </div>
      <div className="breadcrumb">
        <Breadcrumbs
          currentPageName={props.suboption}
          mainoption={props.mainoption}
          to1={props.to1}
        />
      </div>
    </div>
  );
}
